module.exports = function(context, args){
  return new (Function.prototype.bind.apply(context, args));
};



//////////////////
// WEBPACK FOOTER
// ./~/jpex/src/instantiator.js
// module id = 569
// module chunks = 40